import script from "./TelegramNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramNotification.vue?vue&type=script&setup=true&lang=js"

import "./TelegramNotification.vue?vue&type=style&index=0&id=7de8a2c3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de8a2c3"]])

export default __exports__